import { LogoMark } from "./Logo";

const ITEMS = ["JAI हो!", "Crafted in the Himalayas", "Britain's Favourite Indian Cider", "Real Himachali apples", "Raise your glass"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t, i) => (
      <span key={t} className="flex items-center">
        <span className={`whitespace-nowrap px-8 font-display text-5xl italic sm:text-6xl lg:text-8xl ${i % 2 ? "text-outline-white" : "text-white"}`}>{t}</span>
        <LogoMark className="h-10 w-10 shrink-0 lg:h-14 lg:w-14" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div className="relative overflow-hidden border-y border-white/20 bg-forest py-8 lg:py-10" data-testid="editorial-marquee" aria-label="JAI हो! Crafted in the Himalayas. Britain's Favourite Indian Cider.">
      <div className="marquee-track flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
